import "./App.css";
import { Navigate, Route, Routes } from "react-router-dom";
import Login from "./Pages/Login";
import Register from "./Pages/Register";
import Dashboard from "./Pages/Auths/Dashboard";
import Teams from "./Pages/Auths/Teams";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Jobs from "./Pages/Auths/Jobs";
import CreateJobs from "./Pages/Auths/CreateJobs";
import { useAppDispatch, useAppSelector } from "./app/store";
import { useEffect } from "react";
import { checkAuthStatus } from "./features/authSlice";
import UpdateProfile from "./Pages/Auths/UpdateProfile";
import UpdateJobs from "./Pages/Auths/UpdateJobs";
import ManageJobs from "./Pages/Auths/ManageJobs";
import Candidates from "./Pages/Auths/Candidates";
import Interview from "./Pages/Auths/Interview";
import Onboarding from "./Pages/Auths/Onboarding";
import ApplicantProfile from "./Pages/Auths/ApplicantProfile";
import DuplicateJob from "./Pages/Auths/DuplicateJob";
import Protected from "./Components/Headers/Auths/Protected";
import { PuffLoader } from "react-spinners";
import ManageApplicants from "./Pages/Auths/ManageApplicants";
import NotFoundPage from "./Components/NotFoundPage";
import ProtectedLayout from "./Components/Protected/ProtectedLayout";
import Settings from "./Pages/Auths/Settings";
import JobSettings from "./Pages/Auths/JobSettings";
import JobType from "./Components/JobSettings/JobType";
import JobApplication from "./Components/JobSettings/JobApplication";
import JobQuestions from "./Components/JobSettings/JobQuestions";
import SalaryType from "./Components/JobSettings/SalaryType";
import EditJobType from "./Components/JobSettings/EditJobType";
import EditSalaryType from "./Components/JobSettings/EditSalaryType";
import JobQuestionEdit from "./Components/JobSettings/JobQuestionEdit";
import ForgotPassword from "./Pages/ForgotPassword";
import PasswordReset from "./Pages/PasswordReset";

function App() {
  const dispatch = useAppDispatch();

  const { user, isLoggedIn, isLoading } = useAppSelector(
    (state: any) => state.auth
  );

  useEffect(() => {
    dispatch(checkAuthStatus());
  }, [dispatch]);

  if (isLoading) {
    // Render a loader while checking authentication status
    return (
      <PuffLoader
        color="#073367"
        loading={isLoading}
        size={150}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    );
  }

  return (
    <>
      <ToastContainer />
      <Routes>
        <Route
          path="/"
          element={<Navigate to={isLoggedIn ? "/dashboard" : "/login"} />}
        />

        <Route path="/signup" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/password-reset/:token" element={<PasswordReset />} />

        {/* Protected routes */}
        <Route element={<ProtectedLayout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/user-management" element={<Teams />} />
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/createJob" element={<CreateJobs />} />
          <Route path="/profile" element={<UpdateProfile />} />
          {/* <Route path="/updatejob" element={<UpdateJobs />} /> */}
          {/* <Route path="/manageJob" element={<ManageJobs />} /> */}
          <Route path="/candidates" element={<Candidates />} />
          <Route path="/interviews" element={<Interview />} />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/applicantProfile" element={<ApplicantProfile />} />
          <Route path="/duplicateJob/:id" element={<DuplicateJob />} />
          <Route path="/manageJob" element={<ManageJobs />}>
            {/* <Route index element={<UpdateJobs />} /> */}
            <Route
              path="manage-applicants/:id"
              element={<ManageApplicants />}
            />
            <Route
              path="manage-applicants/:id/profile/:applicantId"
              element={<ApplicantProfile />}
            />
            <Route path="details/:id" element={<UpdateJobs />} />
          </Route>
          <Route path="/settings" element={<Settings />} />
          <Route path="/job-settings" element={<JobSettings />}>
            <Route path="job-type" element={<JobType />} />
            <Route path="job-type/:id" element={<EditJobType />} />
            <Route path="job-application" element={<JobApplication />} />
            <Route path="job-application/:id" element={<JobQuestions />} />
            <Route path="salary-type" element={<SalaryType />} />
            <Route path="salary-type/:id" element={<EditSalaryType />} />
            <Route
              path="job-application/edit/:id"
              element={<JobQuestionEdit />}
            />
          </Route>
        </Route>

        {/* Optional: Fallback for unmatched routes */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}

export default App;
